import React from 'react';
import { MachineList } from './MachineList';

interface WeldingMachines {
  [key: string]: {
    enabled: boolean;
    [key: string]: any;
  };
}

interface WeldingSectionProps {
  machines: WeldingMachines | undefined;
  bgColor: string;
  textColor: string;
  className?: string;
}

export const WeldingSection: React.FC<WeldingSectionProps> = ({
  machines,
  bgColor,
  textColor,
  className = ""
}) => {
  if (!machines) return null;

  // Filter CRCE machines (exclude Manual and competitorMachine)
  const crceMachines = Object.entries(machines).reduce((acc, [key, machine]) => {
    if (key !== 'Manual' && key !== 'competitorMachine' && machine.enabled) {
      acc[key] = machine;
    }
    return acc;
  }, {} as Record<string, any>);

  // Check for non-CRCE machines
  const hasNonCRCE = machines.Manual?.enabled || machines.competitorMachine?.enabled;

  return (
    <div className={`space-y-4 ${className}`}>
      <div className={`px-3 py-2 ${bgColor} ${textColor} rounded-md inline-block`}>
        Welding
      </div>
      <div className="space-y-3">
        {/* CRCE Machines */}
        {Object.keys(crceMachines).length > 0 && (
          <div>
            <p className="text-sm font-medium text-gray-700 mb-2">CRCE Machines</p>
            <MachineList machines={crceMachines} />
          </div>
        )}
        
        {/* Non CRCE Machines */}
        {hasNonCRCE && (
          <div>
            <p className="text-sm font-medium text-gray-700 mb-2">Non-CRCE Machines</p>
            <div className="flex flex-wrap gap-2">
              {machines.Manual?.enabled && (
                <div className="px-2 py-1 text-blueprint-blue bg-[rgba(0,39,63,0.06)] rounded text-sm">
                  Manual
                </div>
              )}
              {machines.competitorMachine?.enabled && (
                <div className="px-2 py-1 bg-purple-50 text-purple-500 rounded text-sm">
                  Competitor Machine
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}; 